import mutationHelpers from '../../utils/mutation-helpers';

const state = {
  status: null,
  items: [],
  errors: []
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  UPDATE_STATUS: mutationHelpers.UPDATE_STATUS,
  RESET_ERRORS: mutationHelpers.RESET_ERRORS,
  SET_ERROR: mutationHelpers.SET_ERROR
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
